import { render } from "./adSettingsComponent.vue?vue&type=template&id=0c3d8698&scoped=true"
import script from "./adSettingsComponent.vue?vue&type=script&lang=js"
export * from "./adSettingsComponent.vue?vue&type=script&lang=js"

import "./adSettingsComponent.vue?vue&type=style&index=0&id=0c3d8698&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c3d8698"]])

export default __exports__